export default __webpack_public_path__ + "static/news7-4c415573bf6716a863d6b0719d64a519.jpg";